export default __webpack_public_path__ + "static/media/001.7eefd4c0.jpg";